import { Injectable } from '@angular/core';
import { TopRate } from './dashboard.model';
import { MainRates, Rate } from '../states/dashboard-state';

@Injectable({ providedIn: 'root' })
export class TopRatesTransformerService {
  transform(topRates: TopRate[]): MainRates {
    const mainRates: MainRates = {
      markupRevenueCountry: [],
      grossSalesCountry: [],
      netRevenueCountry: [],
      bookingsCountry: [],
      markupRevenueCity: [],
      grossSalesCity: [],
      netRevenueCity: [],
      bookingsCity: []
    };
    for (const topRate of topRates) {
      switch (topRate.statisticType) {
        case 'NUMBER_OF_BOOKINGS':
          this.extractData(
            mainRates.bookingsCity,
            mainRates.bookingsCountry,
            topRate.destinationType,
            topRate.topRateList
          );
          break;
        case 'NET_REVENUES':
          this.extractData(
            mainRates.netRevenueCity,
            mainRates.netRevenueCountry,
            topRate.destinationType,
            topRate.topRateList
          );
          break;
        case 'GROSS_SALES':
          this.extractData(
            mainRates.grossSalesCity,
            mainRates.grossSalesCountry,
            topRate.destinationType,
            topRate.topRateList
          );
          break;
        case 'REVENUES':
          this.extractData(
            mainRates.markupRevenueCity,
            mainRates.markupRevenueCountry,
            topRate.destinationType,
            topRate.topRateList
          );
          break;
        default:
          break;
      }
    }
    return mainRates;
  }

  private extractData(mainRatesCity: Rate[], mainRatesCountry: Rate[], destinationType: string, newRates: Rate[]) {
    destinationType === 'CITY' ? mainRatesCity.push(...newRates) : mainRatesCountry.push(...newRates);
  }
}
